import { z } from 'zod';

const messageSentExpireConfig = z
  .object({
    referenceTimeType: z.literal('message-sent'),
    timeOffsetMinutes: z.number().int(),
  })
  .loose();

const itemStartTimeExpireConfig = z
  .object({
    referenceTimeType: z.literal('item-start-time'),
    inDayTimeTrigger: z
      .object({ hours: z.number().int(), minutes: z.number().int() })
      .loose()
      .optional(),
    timeOffsetMinutes: z.number().int().optional(),
    minimumResponseMinutes: z.number().int().nonnegative().optional(),
  })
  .loose();

export const expireRuleConfigSchema = z.discriminatedUnion(
  'referenceTimeType',
  [messageSentExpireConfig, itemStartTimeExpireConfig]
);
export type ExpireRuleConfig = z.infer<typeof expireRuleConfigSchema>;

export const expireRuleItemSchema = z.object({
  id: z.uuid(),
  title: z.string().nullable(),
  config: expireRuleConfigSchema,
});
export type ExpireRuleItem = z.infer<typeof expireRuleItemSchema>;

export const createExpireRuleInput = z.object({
  title: z.string().nullable().optional(),
  config: expireRuleConfigSchema,
});
export type CreateExpireRuleInput = z.infer<typeof createExpireRuleInput>;

export const updateExpireRuleInput = z.object({
  id: z.uuid(),
  title: z.string().nullable().optional(),
  config: expireRuleConfigSchema.optional(),
});
export type UpdateExpireRuleInput = z.infer<typeof updateExpireRuleInput>;

export const findExpireRulesInput = z.object({
  offset: z.number().int().nonnegative().optional(),
  limit: z.number().int().min(1).max(200).optional(),
  title: z.string().optional(),
});
export type FindExpireRulesInput = z.infer<typeof findExpireRulesInput>;

export const findExpireRulesResultSchema = z.object({
  data: z.array(expireRuleItemSchema),
  count: z.number().int().nonnegative(),
  countAll: z.number().int().nonnegative(),
});
export type FindExpireRulesResult = z.infer<typeof findExpireRulesResultSchema>;

export const deleteExpireRuleInput = z.object({ id: z.uuid() });
export type DeleteExpireRuleInput = z.infer<typeof deleteExpireRuleInput>;

export const deleteExpireRuleResultSchema = z.object({ id: z.uuid() });
export type DeleteExpireRuleResult = z.infer<
  typeof deleteExpireRuleResultSchema
>;
